@if (dropdownType === 'zone') {
  <div>
    <mat-form-field class="dropdown-container" appearance="outline">
      <mat-select
        placeholder="{{ zoneLabel }}"
        [value]="selectedZone"
        (selectionChange)="onZoneChange($event)"
      >
        @for (zone of zones; track zone) {
          <mat-option [value]="zone.Name">{{ zone.Name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
}
@if (dropdownType === 'defect') {
  <div>
    <mat-form-field class="defect-dropdown-container" appearance="outline">
      <mat-label>{{ defectLabel }}</mat-label>
      <input
        #input
        class="defect-option"
        type="text"
        placeholder="{{ defectPlaceholder }}"
        matInput
        [formControl]="defectControl"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        (optionSelected)="onDefectChange($event)"
      >
        @for (
          option of filteredDefects | async;
          track option.InspectionTaskName
        ) {
          <mat-option [value]="option">
            <div>{{ option.InspectionTaskName }}</div>
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
}
@if (dropdownType === 'location') {
  <div class="defect-dropdown-styling">
    <div class="label">{{ locationLabel }}</div>
    <mat-form-field class="dropdown-container-task" appearance="fill">
      <mat-select
        placeholder="{{ locationPlaceholder }}"
        [formControl]="locationControl"
        (selectionChange)="onLocationChange($event)"
      >
        @for (loc of locations; track loc) {
          <mat-option [value]="loc">{{ loc.Name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
}
@if (dropdownType === 'station') {
  <div class="defect-dropdown-styling">
    <div class="label">{{ stationLabel }}</div>
    <mat-form-field class="dropdown-container-station" appearance="fill">
      <mat-select
        placeholder="{{ stationPlaceholder }}"
        [disabled]="disabled"
        (selectionChange)="onStationChange($event)"
      >
        @for (station of stations; track trackByStationId($index, station)) {
          <mat-option [value]="station">{{ station.Name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
} @if(dropdownType === "managerWalkUser") {
  <div class="mw-dropdown-styling">
    <mat-form-field class="mw-container" appearance="fill">
      <mat-select placeholder="{{ managerWalkLabel }}" [formControl]="managerwalkControl" (selectionChange)="onManagerWalkUserChange($event)">
        @for (user of managerWalkUsers; track user.UserId) {
          <mat-option [value]="user">{{ user.Name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
}